import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

@Injectable({
    providedIn: 'root'
})
export class MsalAccountRepository {
    constructor(private msalService: MsalService) { }

    public getActiveAccount(): AccountInfo | null {
        return this.msalService.instance.getActiveAccount();
    }

    public setActiveAccount(account: AccountInfo | null): void {
        this.msalService.instance.setActiveAccount(account);
    }

    public getAllAccounts(): AccountInfo[] {
        return this.msalService.instance.getAllAccounts();
    }

    public hasActiveAccount(): boolean {
        return !!this.getActiveAccount();
    }

    public enableAccountStorageEvents(): void {
        this.msalService.instance.enableAccountStorageEvents();
    }
}